import { render, staticRenderFns } from "./MedicalCenter.vue?vue&type=template&id=47c7e5ab&scoped=true"
import script from "./MedicalCenter.vue?vue&type=script&lang=js"
export * from "./MedicalCenter.vue?vue&type=script&lang=js"
import style0 from "./MedicalCenter.vue?vue&type=style&index=0&id=47c7e5ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c7e5ab",
  null
  
)

export default component.exports